import { CommonSectionProps } from '@portal/shared/studio/types';
import type { PageTranslation } from 'schema/studio/studio';
import { type getActiveBannerForHeader } from 'shared/utils/bannerVisibility';
import type { HeaderResult, HeaderSection } from 'types/studio/header';
import type { HeaderFullV2, Header as HeaderType } from 'types/studio/studio';

import { HeaderRedesign } from './HeaderRedesign';
import { HeaderV1 } from './HeaderV1';

type Props = {
  className?: string;
  header: HeaderType;
  logoSVG?: string;
  translations?: PageTranslation[];
  theme?: HeaderSection['theme'];
  hasProgressBar?: boolean;
  newThemeProgressBar?: boolean;
  renderCartButton?: (props: { theme?: HeaderSection['theme'] }) => React.ReactNode;
  activeBanner: ReturnType<typeof getActiveBannerForHeader>;
} & Omit<HeaderFullV2, '_type'>;

export const Header = ({
  desktopLayout = 'white',
  mobileLayout = 'white',
  hasDifferentButtons,
  marketingButton,
  logoLink,
  shopLink,
  className,
  header,
  translations,
  logoSVG,
  theme,
  newThemeProgressBar,
  hasProgressBar,
  banner,
  activeBanner,
  renderCartButton,
  stackable
}: Props & CommonSectionProps) => {
  const hasHeaderV2Data = Boolean(header?.navV2 && header?.navV2Menu);

  return hasHeaderV2Data ? (
    <HeaderRedesign
      logoLink={logoLink}
      shopLink={shopLink}
      header={header}
      logoSVG={logoSVG}
      hasDifferentButtons={hasDifferentButtons}
      marketingButton={marketingButton}
      newThemeProgressBar={newThemeProgressBar}
      hasProgressBar={hasProgressBar}
      activeBanner={activeBanner}
      stackable={stackable}
    />
  ) : (
    <HeaderV1
      desktopLayout={desktopLayout}
      mobileLayout={mobileLayout}
      hasDifferentButtons={hasDifferentButtons}
      marketingButton={marketingButton}
      logoLink={logoLink}
      shopLink={shopLink}
      className={className}
      // TODO: Fix type, this should be using the actual Header that we're
      // fetching.
      header={header as HeaderResult}
      translations={translations}
      logoSVG={logoSVG}
      theme={theme}
      newThemeProgressBar={newThemeProgressBar}
      hasProgressBar={hasProgressBar}
      renderCartButton={renderCartButton}
      banner={banner}
    />
  );
};
